import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";

import {
  getServicesByPharmacyIdData,
  addRoomtData,
  setIsLocationLoading,
  updateRoomtData,
  getPharmaciesByCompanyIdData,
  getCompanyPharmaciesCountData
} from "../features/locationSlice/locationSlice";

const reducerName = "location";

// #region State Setters
export const setLocationLoading = (isLoading) => {
  dispatch(setIsLocationLoading(isLoading));
};

// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getServicesByPharmacyId = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(getServicesByPharmacyIdData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = [];
  }
  return result;
};

export const addRoom = async (data) => {
  let result = null;

  try {
    result = await dispatch(addRoomtData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const updateRoom = async (data) => {
  let result = null;

  try {
    result = await dispatch(updateRoomtData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};

export const getPharmaciesByCompanyId = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getPharmaciesByCompanyIdData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }
  return result;
};

export const getCompanyPharmaciesCount = async (companyId) => {
  let result = 0;
  try {
    result = await dispatch(getCompanyPharmaciesCountData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = 0;
  }
  return result;
};

// #endregion
